import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-lg mt-5 pb-5" }, "Versions", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import {
  computed, onMounted, ref,
} from 'vue';
import { Versions, versionsClient } from '@/service/client/versions-client';
import authService from '@/service/auth-service';
import LoadingBar from '@/components/LoadingBar.vue';
import { useStore } from 'vuex';
import VersionsList from './VersionsList.vue';
import VersionsHeader from './VersionsHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VersionsView',
  setup(__props) {

const versions = ref<Versions>([]);
const errorMessage = ref<string>('');
const isLoading = ref<boolean>(true);
const store = useStore();

onMounted(async () => {
  await store.dispatch('loadUserInfo');
  const { userId } = store.getters;
  if (!userId) {
    errorMessage.value = 'Not authorized';
    isLoading.value = false;
    return;
  }
  versions.value = await versionsClient.getAllVersions(userId);

  isLoading.value = false;
});

const validVersions = computed(() => versions.value.filter((e) => e.link));

const filledVersions = computed(() => versions.value && versions.value.length !== 0);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", null, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingBar, { key: 0 }))
        : (filledVersions.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(VersionsHeader),
              _createVNode(VersionsList, { versions: validVersions.value }, null, 8, ["versions"])
            ]))
          : (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(errorMessage.value), 1))
    ])
  ]))
}
}

})